export interface OpenCabQueue {
    actionValue: string;
    actionType: QueueActionType;
}

export enum QueueActionType {
    moveToBackground,
    urlNavigation
}

export enum OpenCabQueueActionTypes {
    ENQUEUE_OPENCABQUEUE = "ENQUEUE_OPENCABQUEUE",
    DEQUEUE_OPENCABQUEUE = "DEQUEUE_OPENCABQUEUE",
    CLEAR_OPENCABQUEUE = "CLEAR_OPENCABQUEUE"
}